export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-base"></i>
              </div>
              <span className="text-lg font-heading text-background-100">女神漫画网</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              女神漫画下拉式在线阅读平台 — 专为手机端优化，提供韩漫、日漫免费全集下拉式阅读体验。
              无需翻页，流畅滚动，沉浸式追漫从这里开始。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-heading text-background-100 mb-4">快速导航</h3>
            <div className="space-y-2">
              {[
                { label: '平台特色', href: '#features' },
                { label: '热门作品', href: '#media' },
                { label: '常见问题', href: '#faq' },
                { label: '精选推荐', href: '#cards' },
                { label: '编辑精选', href: '#carousel' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="block text-sm text-background-400 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading text-background-100 mb-4">热门标签</h3>
            <div className="flex flex-wrap gap-2">
              {['韩漫推荐', '下拉式阅读', '免费全集', '恋爱甜漫', '日漫连载', '手机看漫画'].map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-1 rounded-full text-xs bg-background-800 text-background-400 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading text-background-100 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
            <div className="mt-4">
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-5 py-2 bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-mail-send-line"></i>
                联系我们
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 女神漫画网 — 女神漫画下拉式在线阅读平台。本站内容仅供学习交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span className="cursor-pointer hover:text-background-300 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors">使用条款</span>
          </div>
        </div>
      </div>
    </footer>
  );
}